<template>
  <v-menu
    min-width="400px"
    max-width="400px"
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="{...on }">
        <v-icon>mdi-format-list-bulleted</v-icon>
      </v-btn>
    </template>
    <v-card class="mx-auto">
      <v-card-title class="title font-weight-bold">
        Opções da listagem
      </v-card-title>
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir especificações"
                      v-model="showEspecificacao"
                      @change="onChangeOptions"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir observações internas"
                      v-model="showObservacaoInterna"
                      @change="onChangeOptions"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-switch label="Exibir observações externas"
                      v-model="showObservacaoExterna"
                      @change="onChangeOptions"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { SET_CURRENT_SESSION_STATE_ACTION } from '@/store/requisicao-geracao/actions.type';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
    showEspecificacao: {
      get() {
        return this.$store.getters['requisicaoGeracao/showEspecificacao'];
      },
      set(showEspecificacao) {
        this.$store.dispatch('requisicaoGeracao/showEspecificacao', showEspecificacao);
      },
    },
    showObservacaoExterna: {
      get() {
        return this.$store.getters['requisicaoGeracao/showObservacaoExterna'];
      },
      set(showObservacaoExterna) {
        this.$store.dispatch('requisicaoGeracao/showObservacaoExterna', showObservacaoExterna);
      },
    },
    showObservacaoInterna: {
      get() {
        return this.$store.getters['requisicaoGeracao/showObservacaoInterna'];
      },
      set(showObservacaoInterna) {
        this.$store.dispatch('requisicaoGeracao/showObservacaoInterna', showObservacaoInterna);
      },
    },
  },
  methods: {
    ...mapActions('requisicaoGeracao', {
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeOptions() {
      this.setCurrentSessionState({
        idCurrentEntidade: this.idEntidade,
        idCurrentUser: this.user.id,
      });
    },
  },
};
</script>
